/**
 * May this run skip the desktop sign-in gate (and the plan limits that come
 * with an account)?
 *
 * Only a build MADE for demos and e2e: `REACT_APP_E2E_NO_GATE=1` at build time
 * (`npm run build:e2e`). Create React App inlines `process.env.REACT_APP_*` at
 * build time, so in the release build (`npm run build`, the release workflow)
 * this whole function folds to `false` and nothing set at runtime — not
 * `window.__demoIpc`, not localStorage — can turn it back on.
 *
 * Inside such a build the run must still also BE driven (`isSyntheticRun`:
 * the tauriShim sets `window.__demoIpc`, or `REACT_APP_SYNTHETIC=1`), so an
 * e2e build opened by hand still asks for sign-in.
 *
 * `isSyntheticRun` itself stays what it was — a runtime "don't count me"
 * marker for metrics, explicitly not a security boundary (utils/syntheticRun.js).
 * Owner, 26.10.2026: "the desktop app must never run without sign-in".
 */
import { isSyntheticRun } from '../utils/syntheticRun';

/** Built for demos/e2e. Folded to a constant by the bundler. */
export function isGateExemptBuild() {
  return process.env.REACT_APP_E2E_NO_GATE === '1';
}

/** A demo/e2e build that is being driven right now. Always false in a release build. */
export function isGateExemptRun() {
  return isGateExemptBuild() && isSyntheticRun();
}
